<template>
   <span v-if="!params.labels.length" class="text-grey">-</span>
   <span v-else :title="params.labels.join(', ')">
      {{ visible.join(', ') }}
      <span v-if="hidden" class="text-grey">+{{ hidden }}</span>
   </span>
</template>

<script lang="ts" setup>
import type { AdminLogChangesCellParams, GridCellProps } from '~/composables/grid/cell-params'

const VISIBLE_LABELS = 3

const props = defineProps<GridCellProps<AdminLogChangesCellParams>>()

const visible = computed(() => props.params.labels.slice(0, VISIBLE_LABELS))
const hidden = computed(() => Math.max(props.params.labels.length - VISIBLE_LABELS, 0))
</script>
